;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ["weeklyapplicationscustomers", "monthlyapplicationscustomers", "biweeklyapplicationscustomers", "dates", "default_currency", "current_merchant", "current_service", "selected_merchants"],
  data: function data() {
    return {
      wklappcustomers: [],
      biwklyappcustomers: [],
      monapplicationscustomers: [],
      loading: false,
      annual_data: [],
      selected_year: "",
      selected_year_val: "",
      annual_drill_downs: {},
      selected_merchant: null,
      month_names: {
        1: "jan",
        2: "feb",
        3: "mar",
        4: "apr",
        5: "may",
        6: "jun",
        7: "jul",
        8: "aug",
        9: "sep",
        10: "oct",
        11: "nov",
        12: "dec"
      }
    };
  },

  created: function created() {},
  watch: {
    weeklyapplicationscustomers: function weeklyapplicationscustomers(val) {
      this.renderApplicationsCustomersRevenueGraph("Last 7 days", val, "weekly-applications-customers-currency");
    },
    monthlyapplicationscustomers: function monthlyapplicationscustomers(val) {
      this.renderApplicationsCustomersRevenueGraph("Last 30 days", val, "monthly-applications-customers-currency");
    },
    biweeklyapplicationscustomers: function biweeklyapplicationscustomers(val) {
      this.renderApplicationsCustomersRevenueGraph("Last 14 days", val, "bi-weekly-applications-customers-currency");
    },
    selected_merchants: function selected_merchants() {
      this.selected_merchant = this.selected_merchants;
      this.refresh_data();
    }
  },
  mounted: function mounted() {
    if (this.current_merchant) {
      this.selected_merchant = this.current_merchant;
    }
  },

  methods: {
    refresh_data: function refresh_data() {
      if (this.selected_year) {
        this.selected_year_val = this.selected_year.id;
      }
      this.loadData(this.selected_year_val);
      this.selected_year_val = "";
    },
    loadData: function loadData(the_year) {
      var _this = this;
      this.loading = true;
      if (this.merchant) {
        this.selected_merchant = this.merchant.id;
      }

      $.ajax({
        url: "/api/dashboard/admin/annual",
        method: "GET",
        data: {
          fetch: "annual-view",
          filter: {
            merchant: this.selected_merchant,
            service_accounts: this.current_service && this.current_service.id,
            year: the_year
          }
        },
        success: function success(response) {
          _this.parseDataAndRender(response.data);
        },
        complete: function complete() {
          _this.loading = false;
        }
      });
    },
    parseDataAndRender: function parseDataAndRender(data) {
      var kes_applications = this.generateSeries(data, this.default_currency + " Applications", "kes_applications");

      var usd_applications = this.generateSeries(data, "USD Applications", "usd_applications");

      var kes_revenue = this.generateSeries(data, this.default_currency + " Revenue", "kes_revenue");

      var kes_customers = this.generateSeries(data, this.default_currency + " Customers", "kes_customers");

      var usd_customers = this.generateSeries(data, "USD Customers", "usd_customers");

      var kes_applications_drilldown = this.generateDrilldown(data, this.default_currency + " Applications", "kes_applications");

      var usd_applications_drilldown = this.generateDrilldown(data, "USD Applications", "usd_applications");

      var kes_revenue_drilldown = this.generateDrilldown(data, this.default_currency + " Revenue", "kes_revenue");

      var kes_customers_drilldown = this.generateDrilldown(data, this.default_currency + " Customers", "kes_customers");

      var usd_customers_drilldown = this.generateDrilldown(data, "USD Customers", "usd_customers");

      this.renderGraph("annual-kes-applications", this.default_currency + " Applications", [kes_applications], kes_applications_drilldown);

      this.renderGraph("annual-usd-applications", "USD Applications", [usd_applications], usd_applications_drilldown);

      this.renderGraph("annual-kes-revenue", "Annual " + this.default_currency + " Revenue", [kes_revenue], kes_revenue_drilldown);

      var usd_revenue = this.generateSeries(data, "USD Revenue", "usd_revenue");

      var usd_revenue_drilldown = this.generateDrilldown(data, "USD Revenue", "usd_revenue");

      this.renderGraph("annual-usd-revenue", "Annual USD Revenue", [usd_revenue], usd_revenue_drilldown);

      this.renderGraph("annual-kes-customers", "Annual " + this.default_currency + " Customers", [kes_customers], kes_customers_drilldown);

      this.renderGraph("annual-usd-customers", "Annual USD Customers", [usd_customers], usd_customers_drilldown);
    },
    generateSeries: function generateSeries(data, name, data_key) {
      var _this2 = this;

      return {
        name: name,
        colorByPoint: true,
        data: data.map(function (month) {
          var month_name = _this2.month_names[month.month];
          return {
            name: month_name,
            y: month.days.reduce(function (accum, day) {
              return accum + day.data[data_key];
            }, 0),
            drilldown: data_key + "_" + month_name
          };
        })
      };
    },
    generateDrilldown: function generateDrilldown(data, name, data_key) {
      var _this3 = this;

      return data.map(function (month) {
        return {
          name: name,
          id: data_key + "_" + _this3.month_names[month.month],
          data: month.days.map(function (day) {
            return [day.date, day.data[data_key]];
          })
        };
      });
    },

    renderGraph: function renderGraph(chart_id, title, series, drilldowns) {
      if (this.annual_drill_downs[chart_id]) {
        this.annual_drill_downs[chart_id].destroy();
      }

      this.chart = Highcharts.chart(chart_id, {
        chart: {
          type: "column"
        },
        title: {
          text: title,
          align: "left"
        },
        subtitle: {
          text: "Click the columns for a monthly breakdown",
          align: "left"
        },
        xAxis: {
          type: "category"
        },
        yAxis: {
          title: {
            text: "Values"
          }
        },
        legend: {
          enabled: true,
          align: "right",
          borderWidth: 1,
          borderRadius: 2,
          padding: 15,
          verticalAlign: "top",
          floating: false
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: false,
              format: "{point.y:.1f}%"
            }
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>'
        },
        series: series,
        drilldown: {
          series: drilldowns
        }
      });
    },
    renderApplicationsCustomersRevenueGraph: function renderApplicationsCustomersRevenueGraph(subtitle, data, container) {
      var formatted_data = data.map(function (day) {
        return {
          date: day.day,
          kes_applications: day.default_currency,
          usd_applications: day.usd,
          kes_customers: day.customers,
          usd_customers: day.invoices
        };
      });

      return Highcharts.chart(container, {
        chart: {
          type: "column"
        },
        title: {
          text: "Applications/Customers",
          align: "left"
        },
        subtitle: {
          text: subtitle,
          align: "left"
        },
        legend: {
          enabled: true,
          align: "right",
          borderWidth: 1,
          borderRadius: 2,
          padding: 15,
          verticalAlign: "top",
          floating: false
        },
        xAxis: {
          gridLineWidth: 1,
          tickmarkPlacement: "on",
          categories: formatted_data.map(function (day) {
            return day.date;
          })
        },
        yAxis: {
          gridLineWidth: 1,
          title: {
            text: ""
          }
        },
        tooltip: {
          formatter: function formatter() {
            return "<b>" + this.x + "</b>, " + this.y + "<br/>";
          }
        },
        plotOptions: {
          line: {
            enableMouseTracking: true
          }
        },
        series: [{
          lineWidth: 2,
          color: "#9B0000",
          name: this.default_currency + " Applications",
          fillColor: {
            linearGradient: [0, 0, 0, 350],
            stops: [[0, "rgb(240,221,222)"], [1, "rgba(255, 255, 255, 0.4)"]]
          },
          data: formatted_data.map(function (day) {
            return day.kes_applications;
          })
        }, {
          lineWidth: 2,
          color: "#283c9b",
          name: this.default_currency + " Customers",
          fillColor: {
            linearGradient: [0, 0, 0, 350],
            stops: [[0, "rgb(240,221,222)"], [1, "rgba(255, 255, 255, 0.4)"]]
          },
          data: formatted_data.map(function (day) {
            return day.kes_customers;
          })
        }, {
          lineWidth: 2,
          color: "#3C009B",
          name: "USD Applications",
          fillColor: {
            linearGradient: [0, 0, 0, 350],
            stops: [[0, "rgb(176,145,226)"], [1, "rgba(255, 255, 255, 0.4)"]]
          },
          data: formatted_data.map(function (day) {
            return day.usd_applications;
          })
        }, {
          lineWidth: 2,
          color: "#489b7d",
          name: "USD Customers",
          fillColor: {
            linearGradient: [0, 0, 0, 350],
            stops: [[0, "rgb(176,145,226)"], [1, "rgba(255, 255, 255, 0.4)"]]
          },
          data: formatted_data.map(function (day) {
            return day.usd_customers;
          })
        }]
      });
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"tab-content"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"annual-view-tab","role":"tabpanel","aria-labelledby":"annual-view-tab"}},[_c('v-select',{attrs:{"options":_vm.dates,"label":"name"},on:{"input":_vm.refresh_data},model:{value:(_vm.selected_year),callback:function ($$v) {_vm.selected_year=$$v},expression:"selected_year"}}),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"text-center p-4"},[_c('span',{staticClass:"fa fa-spinner fa-spin fa-2x"})]):_vm._e(),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('div',{staticClass:"mb-5",attrs:{"id":"annual-usd-applications"}}),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('div',{staticClass:"mb-5",attrs:{"id":"annual-usd-customers"}})],1)])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header tbn-tabs justify-content-end"},[_c('div',{staticClass:"col-md-4 nav -nav-tabs btn-group btn-group-toggle pull-right",attrs:{"role":"tablist","data-toggle":"buttons"}},[_c('a',{staticClass:"btn btn-sm btn-light border border-secondary active",attrs:{"href":"#weekly-applications-customers-currency-tab","data-toggle":"tab","role":"tab"}},[_vm._v("7 days")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-light border border-secondary",attrs:{"href":"#bi-weekly-applications-customers-currency-tab","data-toggle":"tab","role":"tab"}},[_vm._v("14 days")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-light border border-secondary",attrs:{"href":"#monthly-applications-customers-currency-tab","data-toggle":"tab","role":"tab"}},[_vm._v("30 days")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-light border border-secondary",attrs:{"href":"#annual-view-tab","data-toggle":"tab","role":"tab"}},[_vm._v("Annual View")])])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-pane fade active show",attrs:{"id":"weekly-applications-customers-currency-tab","role":"tabpanel","aria-labelledby":"seven-days-view-tab"}},[_c('div',{staticStyle:{"width":"100%","height":"350px","overflow-x":"hidden"},attrs:{"id":"weekly-applications-customers-currency"}})])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-pane fade",attrs:{"id":"bi-weekly-applications-customers-currency-tab","role":"tabpanel","aria-labelledby":"fourteen-days-view-tab"}},[_c('div',{staticStyle:{"width":"100%","height":"350px","overflow-x":"hidden"},attrs:{"id":"bi-weekly-applications-customers-currency"}})])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-pane fade",attrs:{"id":"monthly-applications-customers-currency-tab","role":"tabpanel","aria-labelledby":"thirty-days-view-tab"}},[_c('div',{staticStyle:{"width":"100%","height":"350px","overflow-x":"hidden"},attrs:{"id":"monthly-applications-customers-currency"}})])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-5"},[_c('div',{attrs:{"id":"annual-kes-revenue"}}),_vm._v(" "),_c('hr')])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-5"},[_c('div',{attrs:{"id":"annual-usd-revenue"}})])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-5"},[_c('div',{attrs:{"id":"annual-kes-applications"}}),_vm._v(" "),_c('hr')])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-5"},[_c('div',{attrs:{"id":"annual-kes-customers"}}),_vm._v(" "),_c('hr')])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-077ee269", __vue__options__)
  } else {
    hotAPI.reload("data-v-077ee269", __vue__options__)
  }
})()}